import { render } from "./DocumentModal.vue?vue&type=template&id=3e2e1c6e&scoped=true"
import script from "./DocumentModal.vue?vue&type=script&lang=js"
export * from "./DocumentModal.vue?vue&type=script&lang=js"

import "./DocumentModal.vue?vue&type=style&index=0&id=3e2e1c6e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e2e1c6e"]])

export default __exports__